var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "flex",
    {
      staticClass: "login-form",
      attrs: { direction: "column", justify: "center" },
    },
    [
      _c(
        "flex",
        { staticClass: "close-icon-box", attrs: { justify: "between" } },
        [
          _vm.loginType !== "phone"
            ? _c("i", {
                staticClass: "el-icon-arrow-left option-icon",
                on: {
                  click: function ($event) {
                    return _vm.changeLoginType("phone")
                  },
                },
              })
            : _c("i"),
          _vm._v(" "),
          _c("i", {
            staticClass: "el-icon-close option-icon",
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loginType === "phone" && !_vm.boundWeixinStatus,
              expression: "loginType === 'phone' && !boundWeixinStatus",
            },
          ],
          ref: "loginForm",
          attrs: {
            model: _vm.loginForm,
            rules: _vm.rules,
            "label-width": "0px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "phone" } },
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: "请输入手机号" },
                  model: {
                    value: _vm.loginForm.phone,
                    callback: function ($$v) {
                      _vm.$set(_vm.loginForm, "phone", $$v)
                    },
                    expression: "loginForm.phone",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "80px" },
                      attrs: { slot: "prepend", placeholder: "请选择" },
                      slot: "prepend",
                      model: {
                        value: _vm.loginForm.phoneType,
                        callback: function ($$v) {
                          _vm.$set(_vm.loginForm, "phoneType", $$v)
                        },
                        expression: "loginForm.phoneType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "+86", value: "+86" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { prop: "slideStatus" } },
            [_c("slider-verify", { on: { success: _vm.handleSuccess } })],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { prop: "code" } },
            [
              _c(
                "flex",
                { attrs: { justify: "between" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入短信验证码" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.submitLogin.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.loginForm.code,
                      callback: function ($$v) {
                        _vm.$set(_vm.loginForm, "code", $$v)
                      },
                      expression: "loginForm.code",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.codeLoading,
                          expression: "codeLoading",
                        },
                      ],
                      staticClass: "verify-loading",
                      attrs: {
                        "element-loading-spinner": "el-icon-loading",
                        "element-loading-background": "rgba(0, 0, 0, 0.8)",
                      },
                      on: { click: _vm.getcode },
                    },
                    [
                      _c("span", [_vm._v("获取验证码")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.waitStatus,
                              expression: "waitStatus",
                            },
                          ],
                          staticClass: "cutdown-text",
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.cutdown) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "100%" },
                  attrs: { loading: _vm.loginLoading, type: "primary" },
                  on: { click: _vm.submitLogin },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.bindingStatus ? "绑定手机号并登录" : "登录/注册"
                      ) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("wxlogin", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loginType === "wx" || _vm.boundWeixinStatus,
            expression: "loginType === 'wx' || boundWeixinStatus",
          },
        ],
        staticStyle: { "text-align": "center" },
        attrs: {
          scope: "snsapi_login",
          redirect_uri: _vm.wxRedirectUri,
          href: _vm.wxCSSfiLe,
          appid: "wx5d42aa7712b8d498",
          rel: "external nofollow",
        },
      }),
      _vm._v(" "),
      !_vm.bindingStatus && !_vm.boundWeixinStatus && _vm.loginType === "phone"
        ? _c(
            "flex",
            {
              staticClass: "third-login-type-wrapper",
              attrs: { justify: "center" },
            },
            [
              _c("svg-icon", {
                staticClass: "login-type-icon wx",
                attrs: { "icon-class": "wx" },
                nativeOn: {
                  click: function ($event) {
                    return _vm.changeLoginType("wx")
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }